import axios, { type AxiosError, type AxiosInstance } from 'axios'

export const api: AxiosInstance = axios.create({
  baseURL: '',
  withCredentials: true,
  timeout: 15_000,
})

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401 && typeof window !== 'undefined') {
      const next = encodeURIComponent(window.location.pathname + window.location.search)
      if (!window.location.pathname.startsWith('/login')) {
        window.location.assign(`/login?next=${next}`)
      }
    }
    return Promise.reject(err)
  },
)
